module.exports = __webpack_public_path__ + "static/media/puzzle-38-bg.592cfd3f.svg";